import { render, staticRenderFns } from "./CategoryPreview.vue?vue&type=template&id=0f994bac&scoped=true&"
import script from "./CategoryPreview.vue?vue&type=script&lang=js&"
export * from "./CategoryPreview.vue?vue&type=script&lang=js&"
import style0 from "./CategoryPreview.vue?vue&type=style&index=0&id=0f994bac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f994bac",
  null
  
)

export default component.exports